var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.handleScroll),expression:"handleScroll"}],class:_vm.getIllustrationClass},[_c('img',{attrs:{"src":_vm.getIllustrationUrl,"alt":_vm.getIllustrationAlt}})])}
var staticRenderFns = []

export { render, staticRenderFns }